import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';

import type { TransitionProps } from '@material-ui/core/transitions';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '@skyslope/mache';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  dialogBody: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: '328px',
  },
  closeIcon: {
    position: 'absolute',
    right: '0px',
    color: colors.grey[500],
  },
  closeIconWrapper: {
    width: '100%',
    position: 'relative',
  },
  dialogTitle: {
    padding: '48px 24px 16px 24px',
    color: colors.grey[800],
  },
  dialogTitleFont: {
    fontFamily: 'Libre Baskerville',
    fontSize: '30px',
    letterSpacing: '-.5px',
    lineHeight: '40px',
  },
  dialogContent: {
    padding: '0px 24px',
  },
  dialogText: {
    color: colors.grey[800],
    padding: '0px 54px',
  },
  buttonWrapper: {
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 36,
    padding: '0px',
  },
  exitButton: {
    padding: '12px 24px',
    lineHeight: 1,
    marginLeft: 0,
  },
  continueButton: {
    padding: '12px 24px',
    lineHeight: 1,
    marginBottom: 12,
    borderRadius: '20px',
  },
}));

interface IProps {
  showExitSigningModal: boolean;
  closeModal: () => void;
  showConfirmationPage: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Exit = (props: IProps) => {
  const { showExitSigningModal, closeModal, showConfirmationPage } = props;

  const classes = useStyles();

  return (
    <Dialog
      classes={{ paper: classes.dialogBody }}
      open={showExitSigningModal}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <div>
        <div className={classes.closeIconWrapper}>
          <IconButton className={classes.closeIcon}>
            <CloseIcon data-spec="closingIcon" onClick={() => closeModal()} />
          </IconButton>
        </div>
        <DialogTitle className={classes.dialogTitle} id="alert-dialog-slide-title">
          <span className={classes.dialogTitleFont}>Are you sure you want to exit?</span>
        </DialogTitle>
      </div>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText className={classes.dialogText} id="alert-dialog-slide-description">
          By clicking “Exit Signing”, you will lose all of your work. When you’re ready, you can come back to complete
          these signatures. If you do not wish to e-sign, please reach out to your sender.
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.buttonWrapper}>
        <Button
          className={classes.continueButton}
          data-spec="continueSigning"
          color="primary"
          onClick={() => closeModal()}
        >
          Continue Signing
        </Button>
        <Button
          className={classes.exitButton}
          color="primary"
          variant="contained"
          onClick={() => showConfirmationPage()}
        >
          Exit Signing
        </Button>
      </DialogActions>
    </Dialog>
  );
};
// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Exit;
